/* libs/iot4bos/iot4bos-ui-backoffice/src/lib/features/admin-business-profiles/components/business-profile-tags/business-profile-tags.component.scss */
.panel-title {
  font-size: 14px;
  line-height: 12px;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  color: #7e7e7e;
  text-transform: uppercase;
  white-space: nowrap;
}
.business-profile-detail-tag-list {
  padding: 20px 16px 0;
}
.business-profile-detail-tag-list-by-concept {
  padding-bottom: 20px;
}
.tags-button iot-platform-ui-icon {
  width: 14px;
}
/*# sourceMappingURL=business-profile-tags.component.css.map */
